import { Space, Collapse } from 'antd'
import classnames from 'classnames'

import _map from 'lodash/map'
import _groupBy from 'lodash/groupBy'
import _times from 'lodash/times'
import _size from 'lodash/size'
import _isEmpty from 'lodash/isEmpty'

import Paragraph from 'components/Paragraph'
import Title from 'components/Title'

import Styled from './styled'

export default function SelectTextButton({ services, value, onChange = () => null }) {
  const subCategories = _groupBy(services, choice => choice?.product?.subCategory?.name)

  const items = _map(subCategories, (choices, subCategoryName) => {
    return {
      headerLabel: subCategoryName,
      uiRenderer: (
        <Space size={14} direction="vertical">
          {_map(choices, (choice, index) => {
            const title = choice?.product?.name
            const id = choice?.id
            const tips = choice?.tips
            const isActive = value === id
            const code = index + 1

            return (
              <div key={id}>
                <div
                  className={classnames('text-button', { active: isActive })}
                  onClick={() => onChange(id)}
                >
                  <Space size={10} align="start">
                    <div className="circle">
                      <Paragraph>{code}</Paragraph>
                    </div>
                    <Paragraph>{title}</Paragraph>
                  </Space>
                </div>
                {isActive && (
                  <div className="choice-tip-content" dangerouslySetInnerHTML={{ __html: tips }} />
                )}
              </div>
            )
          })}
        </Space>
      ),
    }
  })

  if (_isEmpty(items)) {
    return null
  }

  return (
    <Styled>
      <Collapse ghost defaultActiveKey={_times(_size(items), index => index.toString())}>
        {_map(items, (item, index) => {
          const headerLabel = item?.headerLabel
          const uiRenderer = item?.uiRenderer
          return (
            <Collapse.Panel
              header={
                <div className="header-custom">
                  <Title level={5}>{headerLabel}</Title>
                </div>
              }
              key={index}
            >
              {uiRenderer}
            </Collapse.Panel>
          )
        })}
      </Collapse>
    </Styled>
  )
}
